import { NoPmToolOverlay } from '@linearb/linui-common';
import {
  NO_PM_TOOL_TEXTS,
  TRACKING
} from '../dashboard.doraV2.freeTier.consts';
import history from 'common/RouterHistory';
import AppRouter from 'common/AppRouter';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING as TRACKING_EVENTS } from 'common/constants/constants';

const NoPmToolWidget = () => {
  const clickAndTrack = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CTA_CLICK, {
      page: TRACKING_EVENTS.PAGES.DASHBOARD,
      cta: TRACKING.CTA_TYPE.BUTTON,
      intent: TRACKING.CTA_INTENT.SETUP_PM,
      source_url: window.location.href
    });
    history.push(`${AppRouter.PROJECT_MANAGEMENT.path}?isOrgSettings=true`);
  };

  return (
    <NoPmToolOverlay
      buttonText={NO_PM_TOOL_TEXTS.CONNECT_PM_TOOL_BUTTON}
      background={true}
      leftColumnTitle={NO_PM_TOOL_TEXTS.LEFT_COLUMN_TITLE}
      rightColumnTitle={NO_PM_TOOL_TEXTS.RIGHT_COLUMN_TITLE}
      onClick={clickAndTrack}
      height='80%'
      sx={{ height: '100%' }}
      square={false}
      data-testid='noPmToolWidget'
    >
      {NO_PM_TOOL_TEXTS.CONNECT_PM_TOOL_DESCRIPTION}
    </NoPmToolOverlay>
  );
};

export default NoPmToolWidget;
